import React from 'react';
import { SmartLink } from '@benzinga/analytics';
import { convertSymbolToURLFriendly } from '../Ticker/utils';
import classNames from 'classnames';
import { SessionContext } from '@benzinga/session-context';
import { TrackingManager } from '@benzinga/tracking-manager';

export type QuotePageSlug =
  | 'overview'
  | 'news'
  | 'analyst-ratings'
  | 'guidance'
  | 'dividends'
  | 'earnings'
  | 'insider-trades'
  | 'ideas'
  | 'short-interest';

export interface TickerLinkProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  className?: string;
  name?: string;
  onPressTicker?: (ticker: string) => void;
  symbol: string;
  slug?: QuotePageSlug;
}

export const TickerLink: React.FC<React.PropsWithChildren<TickerLinkProps>> = React.memo(
  ({ children, className, href, name, onPressTicker, slug, symbol, ...props }) => {
    const friendlyUrlSymbol = convertSymbolToURLFriendly(symbol);
    let link = href;
    const session = React.useContext(SessionContext);

    if (!link?.trim()) {
      link = slug ? `/quote/${friendlyUrlSymbol?.toLowerCase()}/${slug}` : `/quote/${friendlyUrlSymbol?.toLowerCase()}`;
    }

    const trackTickerEvent = (symbol = '') => {
      session.getManager(TrackingManager).trackTickerEvent('click', { symbol });
    };

    return (
      <SmartLink
        target="_blank"
        {...props}
        aria-label={`Go to Quote Page for ${name || symbol}`}
        className={classNames('items-end', {
          [`${className}`]: !!className,
          'inline-flex': !className?.includes('inline'),
        })}
        href={link}
        object={symbol}
        onClick={onPressTicker}
        rel="noopener noreferrer"
        trackClickEvent={trackTickerEvent}
      >
        {children}
      </SmartLink>
    );
  },
);
